// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3lN5I","title":"ClientCherryInfo_title__3bU3l","itemText":"ClientCherryInfo_itemText__1fRVH"};